<template>
<form class="h-100" @submit.prevent="handleSubmit">
  <div class="d-flex flex-column h-100">
    <div class="flex-fill overflow-y-auto">
      <div v-for="(merged, key) in mergedSchemes" :key="key" class="aggregate-form-builder-group">
        <h2 class="text-grey-900 text--large mb-2">{{ getLabel(key) }}</h2>
        <component
          :is="merged.component"
          :modelValue="formData[key]"
          @update:modelValue="handleUpdateField(key, $event)"
          v-bind="merged"
          :label="getLabel(key)"
        />
      </div>
    </div>

    <slot name="buttons" :submit="handleSubmit" :clear="handleClear"></slot>
  </div>
</form>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppMultiSelect from '@/common/AppMultiSelect.vue'
import AppTextField from '@/common/AppTextField.vue'
import RoomCheckboxes from '@/common/form-builder/RoomCheckboxes.vue'

import {
  AppAggregateFormBuilderField,
  mergeFieldProps,
} from './formTypes'

type Scheme = AppAggregateFormBuilderField

export default defineComponent({
  name: 'AppAggregateFormBuilder',
  components: {
    AppMultiSelect,
    AppTextField,
    RoomCheckboxes,
  },
  emits: ['submit', 'clear', 'update:fieldValue'],
  props: {
    aggregateScheme: {
      type: Object as PropType<Record<string, Scheme>>,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mergedSchemes(): Record<string, Scheme> {
      const result: Record<string, Scheme> = {}
      for (const key in this.aggregateScheme) {
        result[key] = mergeFieldProps(this.aggregateScheme[key])
      }
      return result
    },
  },
  methods: {
    getLabel(key: string): string {
      return this.$t(`views.DocumentSearchPage.filtersLabels.${key}`)
    },
    handleSubmit() {
      this.$emit('submit', { ...this.formData })
    },
    handleClear() {
      this.$emit('clear')
    },
    handleUpdateField(key: string, value: any) {
      this.$emit('update:fieldValue', { key, value })
    },
  },
})
</script>
